module.exports = __webpack_public_path__ + "img/Kypho PPP.7ef10628.png";